.menu-category {
  display: flex;
  box-sizing: border-box;
}

.menu-category *,
.menu-category *::before,
.menu-category *::after {
  box-sizing: inherit;
}

@media screen and (min-width: 980px) {
  .menu-category {
    position: relative;
    height: 100%;
    background-color: #f7f7f7;
  }
}

.menu-category--opened {
  width: 1200px;
  height: auto;
  border: none;
  z-index: 2;
}

@media screen and (min-width: 980px) and (max-width: 1199px) {
  .menu-category--opened {
    width: calc(100vw - 38px);
  }
}

.menu-category__list {
  position: relative;
  font-size: 14px;
  line-height: 20px;
  width: 100%;
  background-color: #ffffff;
  margin: 0;
  padding: 0;
  border: 1px solid #ededed;
  box-sizing: border-box;
}

.menu-category__list *,
.menu-category__list *::before,
.menu-category__list *::after {
  box-sizing: inherit;
}

@media screen and (min-width: 980px) {
  .menu-category__list {
    max-width: 280px;
  }
}

.menu-category__details-container {
  display: none;
}

@media screen and (min-width: 980px) {
  .menu-category--opened .menu-category__details-container {
    width: 100%;
    display: block;
  }
}

.menu-category__item {
  list-style: none;
}

@media screen and (max-width: 979px) {
  .menu-category__item {
    border-bottom: 1px solid #ededed;
  }

  :host(:not([dir="rtl"])) .menu-category__item {
    padding: 0 12px 0 24px;
  }

  :host([dir="rtl"]) .menu-category__item {
    padding: 0 24px 0 12px;
  }
}

@media screen and (min-width: 980px) {
  .menu-category__item:first-child {
    padding-top: 8px;
  }

  .menu-category__item:last-child {
    padding-bottom: 8px;
  }
}

.menu-category__item-link {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: none;
  color: #333333;
  text-decoration: none;
  font-weight: 400;
}

@media screen and (max-width: 979px) {
  .menu-category__item-link {
    padding: 14px 0;
  }

  .menu-category__item-link:active {
    outline: 0;
    color: #3dcd58;
  }
}

@media screen and (min-width: 980px) {
  .menu-category__item-link {
    cursor: pointer;
  }

  :host(:not([dir="rtl"])) .menu-category__item-link {
    padding: 10px 14px 10px 20px;
  }

  :host([dir="rtl"]) .menu-category__item-link {
    padding: 10px 20px 10px 14px;
  }

  .menu-category__item--opened .menu-category__item-link {
    color: #3dcd58;
  }
}

:host(:not([dir="rtl"])) .menu-category__item-text {
  padding-left: 0;
  padding-right: 12px;
}

:host([dir="rtl"]) .menu-category__item-text {
  padding-right: 0;
  padding-left: 12px;
}

:host(:not([dir="rtl"])) .menu-category__item--opened .menu-category__item-text, :host(:not([dir="rtl"])) .menu-category__item-link:active .menu-category__item-text {
  padding-left: 12px;
  padding-right: 0;
}

:host([dir="rtl"]) .menu-category__item--opened .menu-category__item-text, :host([dir="rtl"]) .menu-category__item-link:active .menu-category__item-text {
  padding-right: 12px;
  padding-left: 0;
}

.menu-category__item-icon {
  display: flex;
  justify-content: center;
  max-height: 28px;
  max-width: 28px;
  min-width: 28px;
  overflow: hidden;
  color: #9fa0a4;
}

:host([dir="rtl"]) .menu-category__item-icon {
  transform: scaleX(-1);
}

.menu-category__item--opened .menu-category__item-icon, .menu-category__item-link:active .menu-category__item-icon {
  color: inherit;
}

.menu-category__details {
  display: none;
}

@media screen and (min-width: 980px) {
  .menu-category__details {
    position: relative;
    padding: 0 20px 20px;
    width: 100%;
    min-height: 300px;
    z-index: 10;
  }

  .menu-category__details--opened {
    display: block;
  }
}

@media screen and (min-width: 980px) {
  .menu-category__details-section {
    margin-top: 20px;
  }

  .menu-category__details-section:first-child {
    margin-top: 0;
  }
}

@media screen and (min-width: 980px) {
  .view-all {
    text-align: center;
    padding: 10px 0;
    border-top: 1px solid #ededed;
  }
}